<template>
    <div class="user-add-modal">
        <el-dialog title="Ajouter un utilisateur" :visible.sync="innerVisible" size="small" :close-on-click-modal="false">
            <el-row :gutter="12">
                <el-col :span="24">
                    <div class="ck-form-item">
                        <label class="ck-form-item-label">Rechercher un utilisateur</label>
                        <el-autocomplete select-when-unmatched style="width: 100%;" v-model="search" :props="autocompleteProps" :fetch-suggestions="querySearch" placeholder="Rechercher un utilisateur..." :trigger-on-focus="false" @select="handleSelect">
                        </el-autocomplete>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="12" v-if="exists">
                <el-col :span="24">
                    <div class="alert alert-error alert-block">
                        <h3>Cet utilisateur est déjà présent au sein de l'établissement</h3>
                    </div>
                </el-col>
            </el-row>

            <ck-form ref='add-user' label-position="top" :read-only="!isNew && !exists">
                <div v-if="selected && !exists">
                    <el-row :gutter="12" v-if="isNew">
                        <el-col :span="24">
                            <div class="alert alert-error alert-block">
                                <h4 style="text-align: left;">Attention</h4>
                                Veuillez bien vérifier l'ensemble des informations que vous renseignez pour cet utilisateur, car celles-ci ne sont modifiables que par l'administrateur de la plateforme
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="12">
                        <el-col :span="4">
                            <ck-form-item label="Civilité" :display="user.CivilityString">
                                <el-select v-model="user.Civility" placeholder="Select">
                                    <el-option v-for="item in civilities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                                <ck-validator :validators="{ validator: $ckValidator.required, model: user.Civility, trigger: 'change' }">
                                    Veuillez indiquer la civilité
                                </ck-validator>
                            </ck-form-item>
                        </el-col>

                        <el-col :span="7">
                            <ck-form-item label="Nom" :display="user.LastName">
                                <el-input v-model="user.LastName" auto-complete="off" type="text"></el-input>
                                <ck-validator :validators="{ validator: $ckValidator.required, model: user.LastName, trigger: 'change' }">
                                    Veuillez indiquer le nom
                                </ck-validator>
                            </ck-form-item>
                        </el-col>

                        <el-col :span="7">
                            <ck-form-item label="Prénom" :display="user.FirstName">
                                <el-input v-model="user.FirstName" auto-complete="off" type="text"></el-input>
                                <ck-validator :validators="{ validator: $ckValidator.required, model: user.FirstName, trigger: 'change' }">
                                    Veuillez indiquer le prénom
                                </ck-validator>
                            </ck-form-item>
                        </el-col>

                        <el-col :span="6">
                            <ck-form-item label="Autorisation" :read-only="!selectGrantLevel" :display="grantLevelFormatter(user)">
                                <el-select v-model="user.GrantLevel" placeholder="Select">
                                    <el-option v-for="item in grantLevels" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                                <ck-validator :validators="{ validator: $ckValidator.required, model: user.GrantLevel, trigger: 'change' }">
                                    Veuillez indiquer le niveau d'autorisation
                                </ck-validator>
                            </ck-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="12">
                        <el-col :span="24">
                            <ck-form-item label="Email" :display="user.PrimaryEMail">
                                <el-input v-model="user.PrimaryEMail" auto-complete="off" type="text"></el-input>
                                <ck-validator :validators="{ validator: $ckValidator.required, model: user.PrimaryEMail, trigger: 'change' }">
                                    Veuillez indiquer l'e-mail
                                </ck-validator>
                                <ck-validator :validators="{ validator: $ckValidator.email, model: user.PrimaryEMail, trigger: 'change' }">
                                    Veuillez indiquer un e-mail valide
                                </ck-validator>
                            </ck-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="12">
                        <el-col :span="12">
                            <ck-form-item label="Numéro de téléphone" :display="user.PhoneNumber">
                                <el-input v-model="user.PhoneNumber" auto-complete="off" type="text"></el-input>
                            </ck-form-item>
                        </el-col>
                        
                        <el-col :span="12">
                            <ck-form-item label="Fonction" :display="user.Role" :read-only="!selectGrantLevel">
                                <el-input v-model="user.Role" auto-complete="off" type="text"></el-input>
                            </ck-form-item>
                        </el-col>
                    </el-row>
                </div>

                <div>
                    <div class="pull-right">
                        <el-button type="default" @click="cancelAdd">Annuler</el-button>
                        <el-button type="primary" @click="endAdd" native-type="submit" :disabled="exists || !user">Enregistrer</el-button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ck-form>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
Vue.component('user-item', {
    functional: true,
    render: function(h, ctx) {
        var item = ctx.props.item;
        return h('li', ctx.data, [
            h('div', { attrs: { 'v-html': item.Label } }, []),
        ]);
    },
    props: {
        item: { type: Object, required: true }
    }
});

export default Vue.component('add-user-modal', {
    props: {
        groupId: {
            default: () => 0
        },
        zoneId: {
            default: () => 0
        },
        selectGrantLevel: {
            type: Boolean,
            default: () => false
        },
        userGrantLevel: {
            default: () => 0
        },
        visible: Boolean
    },
    data() {
        return {
            innerVisible: false,
            search: '',
            isNew: false,
            exists: false,
            selected: false,
            user: {
                UserName: '',
                PrimaryEMail: '',
                Civility: 0,
                FirstName: '',
                LastName: '',
                GrantLevel: 0,
                Role: ''
            },
            civilities: [{ value: 0, label: 'Mr' }, { value: 1, label: 'Mme' }, { value: 2, label: 'Dr' }],
            grantLevels: [
                { value: 0, label: 'Aucune' },
                { value: 8, label: 'Contact' },
                { value: 16, label: 'Viewer' },
                { value: 64, label: 'Editeur' },
                { value: 112, label: 'Administrateur' }
            ],
            autocompleteProps: {
                label: 'Label',
                value: 'Value'
            },
            timeout: null
        }
    },
    mounted: function() {
    },
    methods: {
        querySearch(queryString, cb) {
            if (!queryString) cb([]);

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.$http.get(`/api/user/search?search=${queryString}&groupId=${this.groupId}`).then((response) => {
                    // var styledResult = _.each(response.data, (x) => {
                    //     x.Label = x.Label.replace(queryString, '<b>' + queryString + '</b>')
                    // });

                    if (response.data.length == 0) {
                        if (this.$ckValidator.email(queryString)) {
                            cb([{ Label: 'Creer un nouvel utilisateur', Value: queryString }]);
                        }
                        else {
                            cb([{ Label: 'Veuillez renseigner une adresse e-mail valide pour ajouter un nouvel utilisateur', Value: 'invalid' }]);
                        }
                    }
                    else {
                        cb(response.data);
                    }
                });
            }, 200);

        },
        handleSelect(item) {
            if (item.Value == 'invalid') {
                this.user = {
                    UserName: '',
                    PrimaryEMail: '',
                    Civility: 0,
                    FirstName: '',
                    LastName: '',
                    GrantLevel: 0,
                    Role: ''
                };
                this.isNew = false;
                this.selected = false;
                return;
            }

            this.$http.get(`/api/user/username?username=${item.Value}&groupId=${this.groupId}`).then((response) => {
                this.exists = false;

                if (response.data == 'Exists') {
                    this.exists = true;
                }
                else if (response.data) {
                    response.data.GrantLevel = this.userGrantLevel || 0;
                    _.merge(this.user, response.data);
                    this.selected = true;
                }
                else {
                    this.isNew = true;
                    this.user = {
                        UserName: item.Value,
                        PrimaryEMail: item.Value,
                        Civility: 0,
                        FirstName: '',
                        LastName: '',
                        GrantLevel: this.userGrantLevel,
                        Role: ''
                    };
                    this.selected = true;
                }
            });
        },
        grantLevelFormatter(item) {
            return this.GrantLevelLabels[item.GrantLevel];
        },
        reset() {
            this.user = {
                UserName: '',
                PrimaryEMail: '',
                Civility: 0,
                FirstName: '',
                LastName: '',
                GrantLevel: 0,
                Role: ''
            };
            this.isNew = false;
            this.selected = false;
            this.search = '';
        },
        cancelAdd(e) {
            this.$emit('on-cancel');
            this.reset();
            this.innerVisible = false;
        },
        endAdd(e) {
            e.preventDefault();

            //autocomplete press enter
            if (this.user == null) return;

            this.$refs['add-user'].validate((valid) => {
                if (valid) {
                    this.user.GroupId = this.groupId;
                    this.$http.post('/api/user', this.user).then((response) => {
                        this.$swal({
                            type: 'success',
                            title: 'Enregistré',
                            text: 'L\'utilisateur a bien été ajouté'
                        }).then(() => {

                        });
                        this.reset();
                        this.$emit('on-save');
                        this.$root.$emit('pcr_update_data');
                        this.innerVisible = false;
                    });
                }
                else {
                    this.$swal({
                        type: 'error',
                        title: 'Formulaire invalide',
                        html: 'Veuillez vérifier les informations du formulaire.'
                    });
                }
            });
        }
    },
    watch: {
        innerVisible(val) {
            if(this.visible != val) {
                this.$emit('update:visible', val);
            }
        },
        visible(val) {
            this.innerVisible = val;
            if(!val) {
                this.reset();
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/cross-components/add-user-modal.vue